export const numberConversation = (number: string | number) =>
  new Intl.NumberFormat('en-GB', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2,
  }).format(typeof number === 'string' ? BigInt(number) : number)
